import {QUERY_PRODUCT_PROMOTION} from "../definitions/queries";
import {PROMOTION_FRAGMENT} from "../definitions/fragments";

export const erpService = {
    product: {
        promotion: QUERY_PRODUCT_PROMOTION
    },
    fragments: {
        promotion: PROMOTION_FRAGMENT
    }
}